import { render, staticRenderFns } from "./SkipModal.vue?vue&type=template&id=23f9d842&"
import script from "./SkipModal.vue?vue&type=script&lang=js&"
export * from "./SkipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports